import { render, staticRenderFns } from "./aut-comunidad.vue?vue&type=template&id=5d3f2c72"
import script from "./aut-comunidad.vue?vue&type=script&lang=js"
export * from "./aut-comunidad.vue?vue&type=script&lang=js"
import style0 from "./aut-comunidad.vue?vue&type=style&index=0&id=5d3f2c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports